<template>
  <div class="main-container" :class="colorMode === 'dark' ? 'dark-block' : ''">
    <h2>Is compliance strong enough in your African supply chains?</h2>
    <p>
      Ethics 1st developed by the Center for International Private
      Enterprise (CIPE) not only avoids risks of check-box compliance but also
      provides capacity building tailored to African SMEs.
    </p>
    <div class="action-wrap">
      <a
        @click="openLink"
        class="cta-button"
        :class="colorMode === 'light' ? 'medium-button' : ''"
        >Ethics 1st</a
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'ethics-first',
  props: {
    colorMode: {
      type: String,
    },
  },
  methods: {
    openLink() {
      this.$ga.event({
        eventCategory: 'Click',
        eventAction: 'Conversion',
        eventLabel: 'Ethics 1st Block',
      })
      this.$gtag.event('Conversion', {
        'event_category': 'Click',
        'event_label': 'Ethics 1st Block',
      })
      this.$router.push({ path: '/matching/ethics-1st' })
    },
  },
}
</script>
